import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Swal from 'sweetalert2';
import '../Newsletter/Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSending, setIsSending] = useState(false);

  // Email validation
  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value) {
      setEmailError('Email is required');
      return false;
    } else if (!regex.test(value)) {
      setEmailError('Enter a valid email address');
      return false;
    } else {
      setEmailError('');
      return true;
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    validateEmail(value);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) return;

    setIsSending(true);

    const templateParams = {
      email: email,
     message: 'New subscription request for updates from श्री Var Event & Conference!',

    };

    try {
      await emailjs.send(
        'service_c2jf13w',
        'template_c34kf4z',
        templateParams,
        'UxPRjy8Ztmqt2j8Ls'
      );
      Swal.fire({
        icon: 'success',
        title: 'Subscribed!',
        text: `Thanks for subscribing to श्री Var Event & Conference.`,
      });
      setEmail('');
    } catch (error) {
      console.error('EmailJS Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: 'Something went wrong. Please try again later.',
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="newsletter-section">
     <div className="newsletter-content">
  <h2>Stay Connected with Us</h2>
  <p>
    Receive the latest offers, exclusive invitations, and event highlights directly in your inbox.
  </p>
  <form className="newsletter-form" onSubmit={handleSubscribe}>
    <div className='news-d'>
      <input
        type="email"
        placeholder="Enter your email address"
        value={email}
        onChange={handleChange}
        disabled={isSending}
      />
      {emailError && <span className="error-message">{emailError}</span>}
    </div>
    <button className='news-button' type="submit" disabled={isSending || !!emailError}>
      {isSending ? 'Subscribing...' : 'Stay Updated'}
    </button>
  </form>
</div>

    </div>
  );
};

export default Newsletter;
